module.exports = __webpack_public_path__ + "img/universkin-h-icon.d6e1d168.svg";